import {Injectable} from '@angular/core';
import {ModuleFunction} from '@frontend/directus';
import {getTranslation} from '../../../../../../shared/utils/translation-utils';

@Injectable({
  providedIn: 'root',
})
export class RfiCoverageDisplayService {
  buildFunctionHeaderTooltip(requiredFunctions: ModuleFunction[], lang: string): string {
    const names = this.sortFunctionNames(requiredFunctions, lang);

    return this.renderList(names.map((name) => this.renderCovered(name)));
  }

  buildCountryHeaderTooltip(requiredIsoCodes: string[]): string {
    return this.renderCovered(this.sortLabels(requiredIsoCodes).join(', '));
  }

  private getFunctionName(moduleFunction: ModuleFunction, lang: string): string {
    return getTranslation(moduleFunction.translations, lang)?.name?.trim() || moduleFunction.name;
  }

  private sortFunctionNames(moduleFunctions: ModuleFunction[], lang: string): string[] {
    return this.sortLabels(
      moduleFunctions.map((moduleFunction) => this.getFunctionName(moduleFunction, lang)),
    );
  }

  private sortLabels(labels: string[]): string[] {
    return [...labels].sort((first, second) => first.localeCompare(second));
  }

  private renderList(items: string[]): string {
    if (items.length === 0) {
      return '';
    }

    const listItems = items.map((item) => `<li>${item}</li>`).join('');

    return `<ul class="list-disc pl-4">${listItems}</ul>`;
  }

  private renderCovered(content: string): string {
    return `<span class="text-green">${content}</span>`;
  }
}
